import { z } from "zod";

export const idSchema = () => z.string().trim().uuid("Must be a valid ID");
